module.exports = __webpack_public_path__ + "img/confirm.b3cb4709.png";